(function () {
    'use strict';

    angular
        .module('app')
        .controller('gridsettings', gridsettings);

    gridsettings.$inject = ['$scope', '$state', '$filter', 'columnSetService', '$localStorage', '$timeout', 'columnFactory', 'loginService', '$rootScope']; 

    function gridsettings($scope, $state, $filter, columnSetService, $localStorage, $timeout, columnFactory, loginService, $rootScope) {
        /* jshint validthis:true */
        var vm = this;
        vm.title = 'gridsettings';

        vm.loginService = loginService;

        //loginService.initStrings().then(function () {
        $scope.gridSettingsLabel = loginService.resourceStrings["GRID_SETTINGS"]; // "Grid Settings"
        $scope.columnsLabel = loginService.resourceStrings["COLUMNS"]; // "Columns"
        $scope.columnSetsLabel = loginService.resourceStrings["COLUMN_SETS"]; // "Column Sets"
        //});

        var allCopy = [];
        var currentCopy = [];
        var applied = false;
        $scope.changed = false;
        $scope.columnSetChanged = false;
        $scope.columnsChanged = false;
        vm.activeTab = 0;

        $scope.okClicked = function () {
            if ($scope.columnsChanged) {
                saveColumns();
            }
            if ($scope.columnSetChanged) {
                applyColumnSet();
            }

            $scope.dialogShown = false;
            $scope.changed = false;
            $scope.columnSetChanged = false;
            $scope.columnsChanged = false;
            $scope.gridApi.selection.clearSelectedRows();
            vm.activeTab = 0;
            $scope.columnsGridOptions.data = [];
        }

        $scope.cancelClicked = function () {
            if ($scope.columnsChanged && applied === false) {
                $scope.allColumnDefs = allCopy;
                $scope.columnDefs = currentCopy;
                $scope.columnsChanged = false;
                applied = false;
            }
            $scope.dialogShown = false;
            $scope.gridApi.selection.clearSelectedRows();
            vm.activeTab = 0;
            $scope.columnsGridOptions.data = [];
        }

        $scope.startDrag = function (e, ui) {
            if (!$scope.columnsChanged) {

                allCopy = angular.copy($scope.allColumnDefs);
                currentCopy = angular.copy($scope.columnDefs);
            }
        }

        $scope.endDrag = function (e, ui) {
            $scope.allColumnDefs = $filter('orderBy')($scope.allColumnDefs, 'name');
            //not changing the columnset
            $scope.columnSetChanged = false;
            $scope.columnsChanged = true;
            $scope.changed = true;
            applied = false;
        }

        var saveColumns = function () {
            applied = true;
            var columns = [];
            angular.forEach($scope.columnDefs, function (item, key) {
                var column = { schemaId: item.field, width: item.width };
                columns.push(column);
            });
            $scope.processing = true;
            columnSetService.saveColumnSet({ id: $localStorage.userSettings['columnSetId'], columns: columns }).then(function () {
                $scope.changed = false;
                $scope.processing = false;
                $scope.onApplySettings();
            });
        }

        $scope.gridApi = {};

        var onRegisterApi = function (gridApi) {
            $scope.gridApi = gridApi;
            gridApi.selection.on.rowSelectionChanged($scope, columnSetSelected);
        }

        var selectedColumnSet = {};
 
        var columnSetSelected = function (item) {

            selectedColumnSet = $scope.gridApi.selection.getSelectedRows();

            if (selectedColumnSet.length != 0) {
                $scope.columnSetChanged = true;
                $scope.changed = true;
                columnSetService.getColumnSetColumnsForPreview(item.entity.id).then(function (response) {
                    var response = response;
                    columnFactory.getAvailableColumns().then(function () {
                        $scope.columnsGridOptions.data = [];
                        angular.forEach(response.data, function (item, key) {
                            var allowed = false;
                            var columnObj = {};

                            angular.forEach(columnFactory.availableColumns, function (column, key) {
                                if (item.schemaId == column.schemaID) {
                                    columnObj = { name: column.displayName, schemaId: column.schemaID, width: item.width };
                                    allowed = true;
                                }
                            });
                            if (allowed) {
                                $scope.columnsGridOptions.data.push(columnObj);
                            }
                        });
                    });
                });
            }
            else {
                if (!$scope.columnsChanged) {
                    $scope.changed = false;
                }
                $scope.columnSetChanged = false;
                $scope.columnsGridOptions.data = [];
            }

            
        }

        //apply column set
        var applyColumnSet = function () {
            var csColumns = [];
            $scope.allColumnDefs = [];
            angular.forEach($scope.columnsGridOptions.data, function (item, key) {
                csColumns.push({ schemaId: item.schemaId, width: item.width });
            });

            var columnSet = { id: $localStorage.userSettings['columnSetId'], columns: csColumns };
            columnSetService.saveColumnSet(columnSet).then(function () {
                $scope.onApplySettings();
                $scope.processing = false;
            });
        }

        //filter system column sets
        var systemColumnSets = [];
        systemColumnSets.push('WindowColumnFmtList');
        systemColumnSets.push('WorkAreaColumns');
        systemColumnSets.push('FileGuideColumns');
        systemColumnSets.push('RelationshipBrowserColumns');  
        systemColumnSets.push('SearchResultColumns');
        systemColumnSets.push('SearchResultHistoryColumns');
        systemColumnSets.push('SearchResultRevisionColumns');
        systemColumnSets.push('SearchResultCMDTableColumns');
        systemColumnSets.push('RBConfigFmtList');
        systemColumnSets.push('APIAllFieldsColSet');
        systemColumnSets.push('FGClassicName');
        systemColumnSets.push('FGLibBrowserName');
        systemColumnSets.push('FGFavName');
        systemColumnSets.push('FGInboxName');

        var columnSets = [];
        angular.forEach($scope.columnSets, function (item) {
            if (systemColumnSets.indexOf(item.name) == -1) {
                columnSets.push(item);
            }
        });

        $scope.csGridOptions = {
            data: columnSets,
            enableSelectionBatchEvent: true,
            multiSelect: false,
            modifierKeysToMultiSelect: false,
            enableFullRowSelection: true,
            enableRowHeaderSelection: false,
            useExternalSorting: false,
            enableColumnMenus: false,
            enableColumnResizing: true,
            columnDefs: [
                { name: loginService.resourceStrings["NAME"], field: 'name', width: '40%', minWidth: '100' },
                { name: loginService.resourceStrings["OWNER"], field: 'userName', width: '20%', minWidth: '100' },
                { name: loginService.resourceStrings["COMMENT"], field: 'comment', width: '40%', minWidth: '100' }],
            onRegisterApi: onRegisterApi
        }

        $scope.columnTabSelected = function () {
            $scope.changed = false;
            $scope.columnSetChanged = false;
        }

        $scope.columnSetTabSelected = function () {
            if ($scope.columnsChanged) {
                $scope.allColumnDefs = allCopy;
                $scope.columnDefs = currentCopy;
                $scope.columnsChanged = false;
                applied = false;
                $scope.changed = false;
            }
            
            $timeout(function () {
                $scope.gridApi.grid.handleWindowResize();
                $scope.gridApi.grid.refreshCanvas();
                $scope.gridApi.grid.refresh();
                $scope.columnsGridApi.grid.handleWindowResize();
                $scope.columnsGridApi.grid.refreshCanvas();
                $scope.columnsGridApi.grid.refresh();
            }, 1000);
        }

        $scope.csColumns = [];
        $scope.columnsGridApi = {};
        //columns grid
        var onRegisterApiColumns = function (gridApi) {
            $scope.columnsGridApi = gridApi;
        }

        $scope.columnsGridOptions = {
            data: $scope.csColumns,
            enableSelectionBatchEvent: false,
            multiSelect: false,
            modifierKeysToMultiSelect: false,
            enableFullRowSelection: true,
            enableRowHeaderSelection: false,
            useExternalSorting: false,
            enableColumnMenus: false,
            enableColumnResizing: true,
            columnDefs: [
                { name: loginService.resourceStrings["COLUMNS"], field: 'name', width: '100%', minWidth: '100' }],
            onRegisterApi: onRegisterApiColumns
        }

        //hide the sidebar when kicked to the login page.
        var intercept = $rootScope.$on("$stateChangeStart", function (event, toState, toParams) {
            
            if (toState.name == "login") {
                //unsubscribe
                event.preventDefault();
                intercept();
                $scope.dialogShown = false;
                $timeout(function () {
                    //$state.go('login');
                })
                
            }
        });


        activate();

        function activate() {        
            

        }
    }
})();
